// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import { connect } from "react-redux";
import React from "react";
import Link from "redux-first-router-link";

import { Warning as StyledWarning, WarningForm, ModalFormBody } from "./styles";
import { clearConversationalModalWarn } from "src/actions/chatroom";
import { iconSize } from "src/styles/constants/size";
import * as colors from "src/styles/constants/colors";
import Icon from "src/components/Icon";
import * as atypes from "src/constants/actionTypes";
import { showView } from "src/actions";
import defaultFilter from "src/constants/defaultFilter";
import { getChatroomAddress, getTemplateId } from "src/reducers";

import type { AppState } from "src/types";

type Props = {
  templateId: ?number,
  address: string,
  _clearConversationalModalWarn: Function,
  _showView: Function,
};

const Warning = ({
  templateId,
  address,
  _clearConversationalModalWarn,
  _showView,
}: Props) => {
  return (
    <StyledWarning>
      <WarningForm>
        <h4>
          <span>{i18n.t(k.UNABLE_TO_PERFORM_ACTION)}</span>
          <Icon
            icon="close"
            color={colors.primary}
            onClick={_clearConversationalModalWarn}
            size={iconSize.space_l}
          />
        </h4>

        <ModalFormBody>
          <span>
            {i18n.t(k.YOU_SHOULD_NAVIGATE_TO_CONVERS)}
            <Link
              to={{
                type: atypes.SET_CURRENT_CHATROOM_REQUEST,
                payload: {
                  id: address,
                },
                meta: {
                  query: {
                    templateId,
                  },
                },
              }}
              onClick={() => _showView(defaultFilter.conversations.name)}
            >
              {i18n.t(k.VIEW_IN_ACTIVE_CHAT)}
            </Link>
            {i18n.t(k.TO_PERFORM_THIS_ACTION)}
          </span>
        </ModalFormBody>
      </WarningForm>
    </StyledWarning>
  );
};

const mapStateToProps = ({ app }: { app: AppState }, props) => ({
  address: getChatroomAddress(app, props.roomId),
  templateId: getTemplateId(app, props.roomId),
});

export default connect(mapStateToProps, {
  _clearConversationalModalWarn: clearConversationalModalWarn,
  _showView: showView,
})(Warning);
